import { designDe } from './design.de.js';
import { familyDe } from './family.de.js';
import { foodDe } from './food.de.js';
import { kamersDe } from './kamers.de.js';
import { kioskBoardDe } from './kioskBoard.de.js';
import { kioskPrivacyDe } from './kioskPrivacy.de.js';
import { kioskMoveDe } from './kioskMove.de.js';
import { readAloudDe } from './readAloud.de.js';
import { todoDe } from './todo.de.js';
import { kioskWeatherDe } from './kioskWeather.de.js';
import { kioskTimerDe } from './kioskTimer.de.js';
import { hallwayDe } from './hallway.de.js';
import { kioskRemindersDe } from './reminders.de.js';
// Duits (de-DE): teksten van het bord (zelfde vorm als nl.ts). Du-vorm zoals de je-vorm in het
// Nederlands; kort voor de tegels. Sleutels die in nl.ts zelf staan (common, kiosk, web, …) horen
// hier; de rest in het eigen domeinbestand (design.de.ts, food.de.ts, …). Weekdagen en maanden
// staan er zelf in, zodat het bord ze ook zonder Intl heeft; datums zelf maakt Intl.
export const de = {
    weekdays: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
    weekdaysShort: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
    months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    design: designDe,
    food: foodDe,
    family: familyDe,
    kamers: kamersDe,
    reminders: kioskRemindersDe,
    weather: kioskWeatherDe,
    // Timer op het bord (oprichter 1 okt 2026).
    timer: kioskTimerDe,
    // Golf 6b (0043): het bord in de gang van een gedeelde woning (hallway.de.ts).
    hallway: hallwayDe,
    // 0036: melding "Dit bord stopt op ..." (golf 4).
    privacy: kioskPrivacyDe,
    move: kioskMoveDe,
    readAloud: readAloudDe,
    // 0058: to-do's onder de taken van een lid (todo.de.ts).
    todo: todoDe,
    common: {
        adjustBoard: 'Anpassen',
        refreshBoard: 'Aktualisieren',
        create: 'Neu erstellen',
        agendaBoard: 'Kalender',
        today: 'Heute',
        tomorrow: 'Morgen',
        now: 'Jetzt',
        later: 'Gleich',
        done: 'Fertig',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        back: 'Zurück',
        close: 'Schließen',
    },
    kiosk: {
        ...kioskBoardDe,
        // 0035: gepauzeerd door AMUMIN Beheer (golf 4).
        paused: 'Nur ansehen',
        pausedHint: 'Die Tafel ist gerade nur zum Ansehen. Abhaken geht bald wieder.',
        agenda: 'Kalender',
        tasks: 'Aufgaben',
        rewards: 'Belohnungen',
        nothingToday: 'Heute nichts geplant',
        nothingMore: 'Heute nichts mehr',
        noTasks: 'Heute keine Aufgaben',
        allDone: 'Alles fertig!',
        /** Rustig, buiten het thema Kinderen. */
        allDoneCalm: 'Alles erledigt',
        allDay: 'Ganztägig',
        everyone: 'Alle',
        next: 'Danach',
        startsIn: 'in {time}',
        busyFor: 'noch {time}',
        minutesShort: '{count} Min.',
        hoursShort: '{h} Std. {m} Min.',
        tasksProgress: '{done} von {total} fertig',
        pairTitle: 'Dieses Tablet koppeln',
        pairHint: 'Gib diesen Code auf deinem Handy ein:',
        pairScan: 'Oder scanne den QR-Code mit deinem Handy',
        pairWaiting: 'Warten auf Bestätigung…',
        pairStarting: 'Code wird geholt…',
        pairExpired: 'Code abgelaufen, ein neuer Code wird geholt…',
        pairNoConnection: 'Keine Verbindung zum Server, neuer Versuch…',
        pairQrClaiming: 'Verbinden mit dem QR-Code…',
        pairQrInvalid: 'Dieser QR-Code ist abgelaufen oder wurde schon benutzt. Erstellt in der Eltern-App einen neuen oder verbindet mit dem Code auf diesem Bildschirm.',
        pairQrLimit: 'In eurem Abo ist kein weiteres Tablet möglich. Trennt zuerst ein anderes Tablet in der Eltern-App.',
        pairQrBusy: 'Gerade zu viele Versuche. Wartet eine Minute und scannt den QR-Code dann noch einmal.',
        pairQrOffline: 'Keine Verbindung, darum hat der QR-Code nicht funktioniert. Scannt ihn noch einmal oder verbindet mit dem Code auf diesem Bildschirm.',
        offline: 'Keine Verbindung, letzter Stand von {time}',
        offlineBadge: 'Keine Verbindung',
        renderFailed: 'Das Board kann den Kalender gerade nicht zeigen und versucht es erneut.',
        checkInApp: 'Prüfe dieses Tablet in der Eltern-App',
        staleData: 'Keine aktuellen Daten',
        standaloneTitle: 'Leg das Familienboard auf den Home-Bildschirm',
        standaloneBody: 'Tippe in Safari auf Teilen und dann auf „Zum Home-Bildschirm“. Öffne das Board danach über dieses Symbol, sonst bleibt die Kopplung nicht gespeichert.',
        points: { one: '{count} Punkt', other: '{count} Punkte' },
        tasksLeft: { one: 'Noch {count} Aufgabe', other: 'Noch {count} Aufgaben' },
    },
    web: {
        // 0035: gepauzeerd door AMUMIN Beheer (423 household_paused).
        householdPaused: 'Eure Familientafel ist gerade nur zum Ansehen. Änderungen sind nicht möglich.',
        appName: 'AMUMIN Family Board',
        loginTitle: 'Anmelden',
        email: 'E-Mail-Adresse',
        password: 'Passwort',
        login: 'Anmelden',
        forgotPassword: 'Passwort vergessen?',
        noAccount: 'Noch kein Konto?',
        register: 'Konto erstellen',
        save: 'Speichern',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        remove: 'Löschen',
        loading: 'Wird geladen…',
        retry: 'Erneut versuchen',
        close: 'Schließen',
        reload: 'Neu laden',
        none: 'Keine',
        errorGeneric: 'Etwas ist schiefgelaufen. Versuch es noch einmal.',
        errorNetwork: 'Keine Verbindung zum Server.',
        errorNotFound: 'Diese Seite gibt es nicht.',
        moduleOff: 'Dieser Bereich ist für eure Familie ausgeschaltet.',
        /** 0023/0043: dit lid geeft zelf toestemming (consent_self_required). */
        consentSelfRequired: 'Wer 16 Jahre oder älter ist, gibt dafür selbst die Einwilligung. Prüfen Sie die Altersangaben unter Mitglieder und versuchen Sie es dann erneut.',
        versionConflict: 'Das hat inzwischen jemand anderes geändert. Die Liste wurde neu geladen; versuch es noch einmal.',
        rateLimited: 'Zu viele Versuche. Versuch es in {seconds} Sekunden noch einmal.',
        sessionExpired: 'Deine Sitzung ist abgelaufen. Melde dich erneut an.',
        nav: {
            today: 'Heute',
            agenda: 'Kalender',
            members: 'Mitglieder',
            devices: 'Geräte',
            security: 'Sicherheit',
            household: 'Haushalt',
            logout: 'Abmelden',
        },
        timeInAmsterdam: 'Zeit in Amsterdam',
        browserZoneDiffers: 'Dein Browser steht auf einer anderen Zeitzone; alle Zeiten hier sind Amsterdamer Zeit.',
        householdSwitch: 'Aktiver Haushalt',
        sharedComputer: 'Gemeinsamer oder öffentlicher Computer',
        sharedComputerHint: 'Deine Sitzung läuft nach 24 Stunden ab, und diesem Browser wird nicht vertraut.',
        stayLoggedIn: 'Angemeldet bleiben',
        invalidCredentials: 'E-Mail-Adresse oder Passwort stimmt nicht.',
        emailNotVerified: 'Bestätige zuerst deine E-Mail-Adresse über den Link in der E-Mail.',
        outsideTrustedNetwork: 'Du bist außerhalb eines vertrauenswürdigen Netzwerks. Melde dich erneut mit deinem Passwort und einem E-Mail-Code an.',
        forgetToLogout: 'Vergiss nicht, dich abzumelden, wenn du fertig bist.',
        lockedOut: 'Zu viele fehlgeschlagene Versuche. Versuch es später noch einmal.',
        codeTitle: 'E-Mail-Code',
        codeIntro: 'Wir haben einen 6-stelligen Code an {email} geschickt. Er ist 10 Minuten gültig.',
        codeLabel: 'Code aus der E-Mail',
        codeInvalid: 'Gib die 6 Ziffern aus der E-Mail ein.',
        codeWrong: 'Dieser Code stimmt nicht. Noch {count} Versuche.',
        codeWrongPlain: 'Dieser Code stimmt nicht.',
        codeLocked: 'Zu viele falsche Codes. Melde dich erneut an, um einen neuen Code zu bekommen.',
        codeExpired: 'Der Code ist abgelaufen. Melde dich erneut an, um einen neuen Code zu bekommen.',
        trustBrowser: 'Diesem Browser 30 Tage vertrauen',
        trustBrowserHint: 'Bis {date} fragen wir in diesem Browser nicht mehr nach einem E-Mail-Code.',
        resend: 'Code erneut senden',
        resendIn: 'Erneut senden in {seconds} s',
        resent: 'Neuer Code gesendet; der vorherige Code ist ungültig.',
        notMeLink: 'Das war ich nicht',
        noPendingCode: 'Es läuft kein Anmeldeversuch. Melde dich zuerst an.',
        networkConfirmIntro: 'Bestätige das neue vertrauenswürdige Netzwerk mit dem 6-stelligen Code, den wir an {email} geschickt haben.',
        registerTitle: 'Konto erstellen',
        passwordHint: 'Mindestens 12 Zeichen.',
        passwordTooShort: 'Verwende mindestens 12 Zeichen.',
        passwordTooLong: 'Verwende höchstens 256 Zeichen.',
        emailInvalid: 'Prüfe deine E-Mail-Adresse.',
        passwordRepeat: 'Passwort wiederholen',
        passwordMismatch: 'Die Passwörter stimmen nicht überein.',
        registerDone: 'Prüfe deine E-Mails',
        registerDoneText: 'Wir haben einen Bestätigungslink an {email} geschickt. Klick darauf, um dein Konto zu aktivieren.',
        alreadyAccount: 'Schon ein Konto?',
        emailTaken: 'Mit dieser E-Mail-Adresse gibt es schon ein Konto.',
        passwordBreached: 'Dieses Passwort ist in einem Datenleck aufgetaucht. Wähle ein anderes Passwort.',
        privateEmailHint: 'Tipp: Verwende eine private E-Mail-Adresse, nicht deine Arbeitsadresse.',
        verifyTitle: 'E-Mail-Adresse bestätigen',
        verifyIntro: 'Klick auf den Button, um deine E-Mail-Adresse zu bestätigen.',
        verifyButton: 'Bestätigen',
        verifying: 'Wird bestätigt…',
        verifyDone: 'Deine E-Mail-Adresse ist bestätigt. Du kannst dich jetzt anmelden.',
        verifyInvalid: 'Dieser Link ist ungültig oder abgelaufen.',
        tokenMissing: 'Dieser Link ist unvollständig. Öffne den Link aus der E-Mail noch einmal.',
        toLogin: 'Zur Anmeldung',
        resetTitle: 'Passwort vergessen',
        resetIntro: 'Gib deine E-Mail-Adresse ein. Wenn es ein Konto gibt, schicken wir dir einen Link, um dein Passwort zu ändern (60 Minuten gültig).',
        resetSend: 'Link senden',
        resetSent: 'Wenn es ein Konto mit {email} gibt, ist eine E-Mail unterwegs.',
        resetConfirmTitle: 'Neues Passwort',
        newPassword: 'Neues Passwort',
        resetConfirmButton: 'Passwort ändern',
        resetDone: 'Dein Passwort wurde geändert. Alle vertrauenswürdigen Browser wurden vergessen; bei der nächsten Anmeldung fragen wir wieder nach einem E-Mail-Code.',
        resetInvalid: 'Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen.',
        notMeTitle: 'Das war ich nicht',
        notMeIntro: 'Jemand hat versucht, sich mit deinem Passwort anzumelden. Warst du das nicht? Dann sperren wir dein Konto.',
        notMeWhatHappens: 'Was passiert, wenn du auf den Button drückst:',
        notMeStep1: 'Der laufende Anmeldeversuch wird blockiert.',
        notMeStep2: {
            one: '{count} vertrauenswürdiger Browser wird vergessen.',
            other: '{count} vertrauenswürdige Browser werden vergessen.',
        },
        notMeStep2Unknown: 'Alle vertrauenswürdigen Browser werden vergessen.',
        notMeStep3: {
            one: '{count} offener Anmeldecode wird ungültig.',
            other: '{count} offene Anmeldecodes werden ungültig.',
        },
        notMeStep4: 'Du bekommst eine E-Mail, um ein neues Passwort zu wählen.',
        notMeButton: 'Ja, das war ich nicht',
        notMeDone: 'Erledigt. Prüfe deine E-Mails auf den Link für ein neues Passwort.',
        notMeInvalid: 'Dieser Link ist ungültig oder wurde schon benutzt.',
        stepUpTitle: 'Mit deinem Passwort bestätigen',
        stepUpIntro: 'Für diese Aktion fragen wir noch einmal nach deinem Passwort, auch zu Hause. Das gilt 10 Minuten.',
        stepUpButton: 'Bestätigen',
        stepUpWrong: 'Passwort stimmt nicht.',
        stepUpCancelled: 'Aktion abgebrochen.',
        wizardTitle: 'Deinen Haushalt einrichten',
        wizardIntro: 'Ein paar Dinge für den Anfang; alles lässt sich später ändern.',
        wizardHouseholdName: 'Name des Haushalts',
        wizardHouseholdHint: 'Steht oben auf dem Board, zum Beispiel „Familie Schneider“.',
        wizardYou: 'Dein Name auf dem Board',
        wizardPinTitle: 'Eltern-PIN',
        wizardPinPlaceholder: 'Kommt später: Die PIN für den Elternmodus auf dem Tablet legst du hier mit einer Passwortbestätigung fest.',
        wizardInviteTitle: 'Zweiten Elternteil einladen',
        wizardInvitePlaceholder: 'Kommt später: Einladung per E-Mail; die andere Person bekommt dieselben Rechte in diesem Haushalt.',
        wizardTrustTitle: 'Diesem Netzwerk vertrauen',
        wizardTrustHint: 'Das stellst du unter Sicherheit ein: Dann fragen wir zu Hause nicht nach einem E-Mail-Code.',
        wizardSaved: 'Haushalt gespeichert.',
        householdNameRequired: 'Gib einen Namen ein.',
        todayTitle: 'Heute',
        todayEmpty: 'Heute nichts geplant.',
        tasksTitle: 'Aufgaben',
        tasksEmpty: 'Heute keine Aufgaben.',
        allDay: 'Ganztägig',
        everyone: 'Alle',
        doneBy: 'Erledigt',
        quickAdd: 'Schnell hinzufügen',
        agendaTitle: 'Kalender',
        newEvent: 'Schneller Termin',
        newTask: 'Schnelle Aufgabe',
        title: 'Titel',
        date: 'Datum',
        start: 'Beginn',
        duration: 'Dauer (Minuten)',
        forWhom: 'Für wen',
        allDayLabel: 'Ganztägig',
        icon: 'Symbol',
        iconNone: 'Kein Symbol',
        location: 'Ort',
        createEvent: 'Termin hinzufügen',
        createTask: 'Aufgabe hinzufügen',
        eventCreated: 'Termin hinzugefügt.',
        taskCreated: 'Aufgabe hinzugefügt.',
        titleRequired: 'Gib einen Titel ein.',
        titleTooLong: 'Höchstens 120 Zeichen.',
        dateInvalid: 'Wähle ein gültiges Datum (JJJJ-MM-TT).',
        memberRequired: 'Wähle mindestens ein Mitglied.',
        startInvalid: 'Wähle eine Startzeit (HH:MM).',
        durationInvalid: 'Die Dauer liegt zwischen 5 und 1440 Minuten.',
        listFor: 'Kalender für {date}',
        showDay: 'Anzeigen',
        deleteEvent: 'Termin löschen',
        deleteTask: 'Aufgabe löschen',
        itemDeleted: 'Gelöscht.',
        noEventsDay: 'Keine Termine an diesem Tag.',
        noTasksDay: 'Keine Aufgaben an diesem Tag.',
        membersTitle: 'Mitglieder',
        membersIntro: 'Alle, die auf dem Board stehen, mit oder ohne Login.',
        addMember: 'Mitglied hinzufügen',
        editMember: 'Mitglied bearbeiten',
        memberName: 'Name',
        memberKind: 'Art',
        kindAdult: 'Erwachsener',
        kindChild: 'Kind',
        kindHelper: 'Helfer',
        color: 'Farbe',
        avatarIcon: 'Avatar-Symbol',
        ageBand: 'Altersgruppe',
        ageBandNone: 'Nicht angegeben',
        nameRequired: 'Gib einen Namen ein.',
        nameTooLong: 'Höchstens 40 Zeichen.',
        memberSaved: 'Mitglied gespeichert.',
        colorNames: {
            orange: 'Orange',
            skyblue: 'Himmelblau',
            bluishgreen: 'Blaugrün',
            yellow: 'Gelb',
            blue: 'Blau',
            vermillion: 'Zinnoberrot',
            reddishpurple: 'Rotviolett',
            black: 'Schwarz',
        },
        devicesTitle: 'Geräte',
        devicesEmpty: 'Noch kein Tablet gekoppelt.',
        pairDevice: 'Koppeln',
        deviceName: 'Name',
        room: 'Raum',
        status: 'Status',
        lastSeen: 'Zuletzt gesehen',
        lastSync: 'Letzte Synchronisierung',
        statusActive: 'Aktiv',
        statusRevoked: 'Widerrufen',
        statusSuspect: 'Verdächtig',
        online: 'Online',
        offline: 'Offline',
        never: 'Noch nie',
        justNow: 'gerade eben',
        minutesAgo: { one: 'vor {count} Minute', other: 'vor {count} Minuten' },
        hoursAgo: { one: 'vor {count} Stunde', other: 'vor {count} Stunden' },
        daysAgo: { one: 'vor {count} Tag', other: 'vor {count} Tagen' },
        rename: 'Umbenennen',
        revoke: 'Widerrufen',
        revokeConfirm: 'Möchtest du „{name}“ wirklich widerrufen? Das Tablet zeigt dann innerhalb einer Minute den Kopplungsbildschirm.',
        revokeYes: 'Ja, widerrufen',
        deviceRevoked: 'Gerät widerrufen.',
        deviceSaved: 'Gerät gespeichert.',
        appVersion: 'Version',
        standalone: 'Home-Bildschirm-App',
        swState: 'Service Worker',
        storageOk: 'Speicher',
        clockOffset: 'Uhrabweichung',
        pairTitle: 'Tablet koppeln',
        pairIntro: 'Gib den Code ein, den das Tablet zeigt.',
        pairCode: 'Code',
        pairReviewIntro: 'Prüfe den Code auf deinem Tablet und wähle Name und Raum.',
        pairConnect: 'Dieses Tablet verbinden',
        pairMatch: 'Stimmt dieser Code mit dem Code auf deinem Tablet überein?',
        pairChangeCode: 'Anderen Code eingeben',
        pairDetails: 'Gerätedetails',
        pairNameLabel: 'Name für dein Tablet',
        pairNameHint: 'Du kannst den Namen später ändern.',
        pairNext: 'Gehe zurück zum Tablet. Das Board öffnet sich dort automatisch.',
        pairCodeInvalid: 'Der Code hat 8 Zeichen, zum Beispiel 1234-5678.',
        pairLookup: 'Code prüfen',
        pairNotFound: 'Unbekannter oder abgelaufener Code. Prüfe den Code auf dem Tablet.',
        pairTooMany: 'Zu viele falsche Codes in dieser Sitzung. Melde dich erneut an.',
        pairUserAgent: 'Browser',
        pairPlatform: 'Plattform',
        pairCountry: 'Land',
        pairStarted: 'Gestartet',
        pairUnknown: 'unbekannt',
        pairApprove: 'Bestätigen',
        pairApproved: 'Tablet „{name}“ gekoppelt. Das Board erscheint in wenigen Sekunden.',
        roomRequired: 'Wähle einen Raum.',
        toDevices: 'Zu den Geräten',
        securityTitle: 'Sicherheit',
        trustedNetworksTitle: 'Vertrauenswürdige Netzwerke',
        trustedNetworksIntro: 'In einem vertrauenswürdigen Netzwerk fragen wir nicht nach einem E-Mail-Code; dein Passwort brauchst du immer.',
        trustThisNetwork: 'Diesem Netzwerk vertrauen',
        trustServerWan: 'Internetadresse des Servers vertrauen',
        currentPrefix: 'Du bist gerade im Netz {prefix}',
        serverWanLabel: 'Internetadresse des Servers: {ip}',
        currentPrefixUnknown: 'Deine Internetadresse ist unbekannt.',
        networkNoSuggestion: 'Dieses Netzwerk kann nicht als vertrauenswürdig hinzugefügt werden (zum Beispiel ein lokales oder ein geteiltes Providernetz).',
        networkAlreadyTrusted: 'Diesem Netzwerk wird schon vertraut.',
        addNetwork: 'Netzwerk hinzufügen',
        label: 'Bezeichnung',
        labelRequired: 'Gib eine Bezeichnung ein.',
        kind: 'Art',
        kindCidr: 'Netzwerk (CIDR, z. B. 192.168.1.0/24)',
        kindIp: 'Eine Adresse (IPv4)',
        kindServerWan: 'Internetadresse des Servers (wird automatisch nachgeführt)',
        kindDdns: 'DDNS-Hostname',
        value: 'Wert',
        valueInvalid: 'Ungültiger Wert für diese Art von Netzwerk.',
        valueIpv6: 'IPv6 wird noch nicht unterstützt.',
        valueCgnat: 'Diese Adresse gehört zu einem geteilten Providernetz (CGNAT) und kann nicht als vertrauenswürdig gelten.',
        scope: 'Gilt für',
        scopeHousehold: 'Den ganzen Haushalt',
        scopeIdentity: 'Nur mich',
        rememberDefault: '„Angemeldet bleiben“ ist in diesem Netzwerk standardmäßig an',
        officeWarning: 'Alle hinter dieser Adresse überspringen die E-Mail-Prüfung – ist das eine feste Geschäftsadresse?',
        mobileHint: 'Mobil oder über 4G? Dann nutze bei der Anmeldung lieber „Diesem Browser 30 Tage vertrauen“.',
        networkCreated: 'Netzwerk hinzugefügt. Bestätige es mit dem E-Mail-Code.',
        networkConfirmed: 'Netzwerk bestätigt. In diesem Netzwerk fragen wir nicht mehr nach einem E-Mail-Code.',
        unconfirmed: 'Noch nicht bestätigt',
        confirmedAt: 'Bestätigt',
        lastMatched: 'Zuletzt erkannt',
        disabledLabel: 'Aus',
        enabledLabel: 'An',
        disable: 'Ausschalten',
        enable: 'Einschalten',
        thisNetwork: 'dieses Netzwerk',
        noNetworks: 'Noch keine vertrauenswürdigen Netzwerke.',
        trustedBrowsersTitle: 'Vertrauenswürdige Browser',
        trustedBrowsersIntro: 'Nach Passwort und E-Mail-Code vertrauen wir einem Browser 30 Tage; danach fragen wir wieder nach einem Code.',
        thisBrowser: 'Dieser Browser',
        issued: 'Ausgestellt',
        trustedUntil: 'Vertraut bis {date}',
        lastUsedAt: 'zuletzt benutzt {when}',
        expiresOn: 'läuft ab am {date}',
        todayAt: 'heute {time}',
        yesterdayAt: 'gestern {time}',
        expires: 'Läuft ab',
        lastUsed: 'Zuletzt benutzt',
        forget: 'Vergessen',
        forgetOthers: 'Alle anderen Browser vergessen',
        noTrustedBrowsers: 'Keine vertrauenswürdigen Browser.',
        browserForgotten: 'Browser vergessen.',
        sessionsTitle: 'Sitzungen',
        routeLabel: 'Anmeldung über',
        routeBrowser: 'vertrauenswürdiger Browser',
        routeNetwork: 'vertrauenswürdiges Netzwerk',
        routeOnce: 'einmalig (24 Stunden)',
        routeNone: 'keiner',
        thisSession: 'Diese Sitzung',
        revokeSession: 'Beenden',
        logoutEverywhere: 'Überall abmelden',
        logoutForget: 'Abmelden und diesen Browser vergessen',
        sessionRevoked: 'Sitzung beendet.',
    },
};
//# sourceMappingURL=de.js.map